"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.ansiToInlineStyle = ansiToInlineStyle;

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _anser = require("anser");

var _escapeCarriage = require("escape-carriage");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * ansiToJson
 * Convert ANSI strings into JSON output.
 *
 * @name ansiToJSON
 * @function
 * @param {String} input The input string.
 * @return {Array} The parsed input.
 */
function ansiToJSON(input) {
  input = (0, _escapeCarriage.escapeCarriageReturn)(input);
  return (0, _anser.ansiToJson)(input, {
    json: true,
    remove_empty: true
  });
}

function ansiJSONtoStyleBundle(ansiBundle) {
  var style = {};
  if (ansiBundle.bg) {
    style.backgroundColor = "rgb(" + ansiBundle.bg + ")";
  }
  if (ansiBundle.fg) {
    style.color = "rgb(" + ansiBundle.fg + ")";
  }
  return {
    content: ansiBundle.content,
    style: style
  };
}

function ansiToInlineStyle(text) {
  return ansiToJSON(text).map(ansiJSONtoStyleBundle);
}

function linkifyBundle(bundle) {
  return _extends({}, bundle, {
    content: bundle.content.split(" ").reduce(function (result, word, index) {
      return [].concat(_toConsumableArray(result), [
      // Unless word is the first, prepend a space
      index === 0 ? "" : " ",
      // If word is a URL, return an <a> element
      /(https?:\/\/(?:www\.|(?!www))[^\s\.]+\.[^\s]{2,}|www\.[^\s]+\.[^\s]{2,})/.test(word) ? React.createElement("a", {
        key: index,
        href: word,
        target: "_blank"
      }, "" + word) : word]);
    }, [])
  });
}

function inlineBundleToReact(bundle, key) {
  return React.createElement("span", {
    style: bundle.style,
    key: key
  }, bundle.content);
}

function Ansi(props) {
  return React.createElement("code", { className: props.className }, props.linkify ? ansiToInlineStyle(props.children).map(linkifyBundle).map(inlineBundleToReact) : ansiToInlineStyle(props.children).map(inlineBundleToReact));
}

var _default = Ansi;
exports.default = _default;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ansiToJSON, "ansiToJSON", "src/index.js");
  reactHotLoader.register(ansiJSONtoStyleBundle, "ansiJSONtoStyleBundle", "src/index.js");
  reactHotLoader.register(ansiToInlineStyle, "ansiToInlineStyle", "src/index.js");
  reactHotLoader.register(linkifyBundle, "linkifyBundle", "src/index.js");
  reactHotLoader.register(inlineBundleToReact, "inlineBundleToReact", "src/index.js");
  reactHotLoader.register(Ansi, "Ansi", "src/index.js");
  reactHotLoader.register(_default, "default", "src/index.js");
  leaveModule(module);
})();

;


//////////////////
// WEBPACK FOOTER
// ./~/ansi-to-react/lib/index.js
// module id = 124
// module chunks = 186292428941015